import React from 'react';
import styles from './ConfirmModal.module.scss';

interface ConfirmModalProps {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ message, onConfirm, onCancel }) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <p>{message}</p>
        <div className={styles.actions}>
          <button onClick={onConfirm} className={styles.confirm}>Oui</button>
          <button onClick={onCancel} className={styles.cancel}>Annuler</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
